import HomePage from '@/pages/HomePage.vue'
import ROUTE_NAMES from '@/constants/routeNames'

export default [
  {
    path: '/',
    name: ROUTE_NAMES.HOME,
    component: HomePage,
    meta: {
      title: 'Wybór Rodziny - Szlachetna Paczka',
      initialIsDisplayChat: false,
      initialIsHideChatOnClose: false
    },
    query: {
      action: true,
      place: true
    }
  },
  {
    path: '/secure',
    name: ROUTE_NAMES.HOME_SECURE,
    component: HomePage,
    meta: {
      title: 'Wybór Rodziny - Szlachetna Paczka',
      initialIsDisplayChat: false,
      initialIsHideChatOnClose: false,
      metaTags: [
        {
          name: 'robots',
          content: 'noindex, follow'
        }
      ]
    }
  }
]
